import axios from "axios";
import Vue from "vue";
// 配置axios
const instance = axios.create({
    baseURL: '/lanyue-study',
    timeout: 30000
})

// 请求拦截器
instance.interceptors.request.use(config => {
    return config;
})

// 响应拦截器
instance.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        // 统一错误处理（示例）
        // console.log('异常打印:'+error)
        const errorMessage = error.response?.data?.message || '请求失败'
        // ElementUI.Message.error("系统异常请联系管理员!")
        return Promise.reject(error)
    }
)

// 挂载到Vue原型
Vue.prototype.$axios = instance


export default instance;